import * as React from "react";
import { Component } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Redirect } from "react-router";
import LoginForm from "src/components/auth/LoginForm";
import RegistrationForm from "src/components/auth/RegistrationForm";
import "../../css/pages/auth/loginpage.css";
import { ILoginPageProps, ILoginPageState } from "./interfaces";

export default class LoginPage extends Component<ILoginPageProps, ILoginPageState> {
  public constructor(props: ILoginPageProps) {
    super(props);

    this.state = {
      key: 1,
      loading: false,
      submitting: false,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.updateLoginState = this.updateLoginState.bind(this);
  }

  public render() {
    const { appService } = this.props;
    if (appService.isAuthenticated()) {
      const { goingTo } = this.props.history.location.state || { goingTo: { pathname: "/" } };
      return <Redirect to={goingTo} />;
    }

    return (
      <div className="root-container container-fixed-navbar">
        <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="loginPage">
          <Tab eventKey={1} title="Login" className="box-container">
            <LoginForm
              appService={this.props.appService}
              setUser={this.props.setUser}
              updateLoginState={this.updateLoginState}
            />
          </Tab>
          <Tab eventKey={2} title="Register" className="box-container">
            <RegistrationForm appService={this.props.appService} setUser={this.props.setUser} />
          </Tab>
        </Tabs>
      </div>
    );
  }

  private handleSelect(key: any) {
    this.setState({ key });
  }

  private updateLoginState(submitting: boolean): void {
    this.setState({ submitting });
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/LoginPage.tsx